import React, { useContext, useState } from 'react';
import './CitizenReportsInformation.css';
import { ReactComponent as CloseForm } from './images/close-message.svg';
import { ReactComponent as InfoButton } from './images/info.svg';
import { useMutation, useQuery } from '@tanstack/react-query';

import { formatInTimeZone } from 'date-fns-tz';
import ConfirmationMessage from './ConfirmationMessage';
import { AppInfoContext, UserContext } from '../../../../App';
import ImageModal from './ImageModal';
import expandImageIcon from './images/expand.svg';
import noImageIcon from './images/no-image.svg';

function CitizenReportsInformation(props) {
  const [errorMessage, setErrorMessage] = useState(false);
  const { userDetails } = useContext(UserContext);
  const token = localStorage.getItem('token');
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const reloadData = () => {
    const currentZoom = window.map.getView().getZoom();
    window.map.getView().setZoom(currentZoom + 0.0001);
  };

  const fetchReportStatus = async ({ queryKey }) => {
    const [_, issueId] = queryKey;
    const token = localStorage.getItem('token');

    const response = await fetch(`${apiUrl}/issues/${issueId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return response.json();
  };

  const { data, isLoading } = useQuery(
    ['issueInformation', props.issueId],
    fetchReportStatus,
    {
      onSuccess: (response) => {
        //   setReportStatusData(response);
        if (response.statusCode > 299 || response.statusCode < 200) {
          // setShowErrorMessage(response.statusCode);
        }

        //   setShowMessage(true);
        //   setReportStatusLoading(false);
      },
      onError: (error) => {
        //   setShowErrorMessage(500);
        //   setShowMessage(true);
        //   setReportStatusLoading(false);
      },
    }
  );

  const { mutate: acceptIssueMutate } = useMutation({
    mutationFn: (issueData) =>
      fetch(`${apiUrl}/issues/${props.issueId}/status`, {
        method: 'PATCH',
        body: JSON.stringify({
          status: 3,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        setMessageText('Kvar koji ste odabrali je prihvaćen.');
        setMessageTitle('Prihvatanje kvara');
        reloadData();
        setShowMessage(true);
        window.popup.hide();

        return;
      }
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const { mutate: rejectIssueMutate } = useMutation({
    mutationFn: (issueData) =>
      fetch(`${apiUrl}/issues/${props.issueId}/status`, {
        method: 'PATCH',
        body: JSON.stringify({
          status: 2,
          statusComment: rejectionReason === '' ? null : rejectionReason,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        setRejectReportPopup(false);

        setMessageText('Kvar koji ste odabrali je odbačen.');
        setMessageTitle('Odbacivanje kvara');
        reloadData();
        setShowMessage(true);
        window.popup.hide();

        return;
      }
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const [rejectReportPopup, setRejectReportPopup] = useState(false);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [messageText, setMessageText] = useState(null);
  const [messageTitle, setMessageTitle] = useState(null);
  const [showUserDetails, setShowUserDetails] = useState(false);

  const handleShowReason = () => {
    setMessageTitle('Razlog odbijanja kvara');
    setMessageText(data.statusComment);
    setShowMessage(true);
  };

  const handleReject = (e) => {
    e.preventDefault();
    rejectIssueMutate();
  };
  const { setAppInformation } = useContext(AppInfoContext);

  const closeInfoModal = () => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      reports: { showInfoModal: false, id: null },
    }));
  };

  const [showImageOnPhone, setShowImageOnPhone] = useState(false);

  const closeMessageModal = () => {
    props.closeIssueInformation();
    closeInfoModal();
  };

  const geoUrl = process.env.REACT_APP_GEOSERVER;

  return (
    <div
      className={
        !rejectReportPopup &&
        !showMessage &&
        'citizen-report-details citizen-report-details-mobile'
      }
    >
      <div
        className={
          rejectReportPopup || showMessage
            ? 'crd-bg-shadow'
            : 'crd-bg-shadow-mobile'
        }
        onClick={closeInfoModal}
      ></div>

      {!showMessage && (
        <div className={'crd-container'}>
          {!isLoading && !errorMessage && !rejectReportPopup && (
            <>
              <div className="crd-header">
                <div className="crd-header-title">Detalji prijave kvara</div>
                <button
                  style={{ fontWeight: 'bolder' }}
                  className="crd-close-button"
                  onClick={closeInfoModal}
                >
                  <CloseForm style={{ height: '10px' }} />
                </button>
              </div>
              <div className="crd-body-container">
                {!isLoading && data.image ? (
                  <div className="citizen-reports-image-desktop">
                    <img
                      src={`${geoUrl}/static/issues/${data.image}`}
                      className="citizen-reports-image-preview"
                      alt=""
                    />
                    <div
                      className="citizen-reports-full-screen"
                      onClick={() => setShowImageOnPhone(true)}
                    >
                      <img
                        src={expandImageIcon}
                        style={{ height: '18px' }}
                        alt="Icon"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="citizen-reports-no-image citizen-reports-image-desktop">
                    <img
                      src={noImageIcon}
                      className="citizen-reports-no-image-preview "
                      alt=""
                    />
                  </div>
                )}
                <div className="crd-body">
                  <div className="crd-main">
                    <div className="crd-all-info">
                      <div className="crd-info-box">
                        <label
                          htmlFor="guestName"
                          className="crd-info-box-title"
                        >
                          Prijavu izvršio/la
                        </label>
                        <div className="crd-reported-by-info">
                          <input
                            type="text"
                            id="guestName"
                            name="guestName"
                            className={
                              data.guestName
                                ? 'crd-field crd-reported-by'
                                : 'crd-field'
                            }
                            maxLength="30"
                            value={
                              !data.guestName
                                ? 'Anonimni građanin/ka'
                                : data.guestName
                            }
                            disabled
                          />

                          {data.guestName && (
                            <div
                              className="crd-reported-by-detail"
                              onClick={() =>
                                setShowUserDetails((prevState) => !prevState)
                              }
                            >
                              <InfoButton style={{ height: '20px' }} />
                              {showUserDetails && (
                                <div className="crd-reported-by-popup">
                                  <div className="crd-reported-by-popup-container crd-reported-by-popup-container-space">
                                    <div className="crd-reported-by-popup-label">
                                      Email:
                                    </div>

                                    <div className="crd-reported-by-popup-value">
                                      {data.guestEmail}
                                    </div>
                                  </div>

                                  <div className="crd-reported-by-popup-container">
                                    <div className="crd-reported-by-popup-label">
                                      Broj telefona:
                                    </div>

                                    <div className="crd-reported-by-popup-value">
                                      {data.guestNumber}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="crd-info-box">
                        <label htmlFor="address" className="crd-info-box-title">
                          Adresa kvara
                        </label>
                        <input
                          type="address"
                          id="address"
                          name="address"
                          className="crd-field"
                          maxLength="40"
                          value={data.address}
                          disabled
                        />
                      </div>
                      <div className="crd-info-box">
                        <label
                          htmlFor="description"
                          className="crd-info-box-title"
                        >
                          Opis kvara
                        </label>
                        <textarea
                          id="description"
                          name="description"
                          className="crd-field crd-textbox"
                          maxLength="180"
                          value={data.description}
                          disabled
                        />
                      </div>
                      <div className="crd-date-time">
                        <div className="crd-info-box">
                          <label
                            htmlFor="reportedDate"
                            className="crd-info-box-title"
                          >
                            Datum prijave
                          </label>
                          <input
                            type="text"
                            id="reportedDate"
                            name="reportedDate"
                            className="crd-field crd-date-time-input"
                            value={formatInTimeZone(
                              data.reportedAt,
                              'Europe/Paris',
                              'dd.MM.yyyy.'
                            )}
                            disabled
                          />
                        </div>
                        <div className="crd-info-box">
                          <label
                            htmlFor="reportedTime"
                            className="crd-info-box-title"
                          >
                            Vrijeme prijave
                          </label>
                          <input
                            type="text"
                            id="reportedTime"
                            name="reportedTime"
                            className="crd-field crd-date-time-input"
                            value={formatInTimeZone(
                              data.reportedAt,
                              'Europe/Paris',
                              'HH:mm'
                            )}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="crd-info-box crd-image-phone">
                        <button
                          className="crd-open-image-modal-button"
                          onClick={() => setShowImageOnPhone(true)}
                        >
                          Otvori fotografiju
                        </button>

                        {showImageOnPhone && (
                          <ImageModal
                            image={data.image}
                            title={'Fotografija kvara'}
                            folder={'issues'}
                            closeModal={() => setShowImageOnPhone(false)}
                          />
                        )}
                      </div>

                      {showImageOnPhone && (
                        <ImageModal
                          image={data.image}
                          title={'Fotografija kvara'}
                          folder={'issues'}
                          closeModal={() => setShowImageOnPhone(false)}
                        />
                      )}

                      <div className="crd-information-buttons crd-information-buttons-mobile">
                        {data.status === 3 ||
                        data.status === 4 ||
                        data.status === 5 ? (
                          <div
                            className="crd-status-info"
                            style={{
                              borderColor: '#079C6A',
                              color: '#079C6A',
                            }}
                          >
                            Prijava prihvaćena
                          </div>
                        ) : data.status === 2 ? (
                          <div
                            className="crd-status-info"
                            style={{
                              borderColor: '#E74049',
                              color: '#E74049',
                            }}
                          >
                            Prijava odbačena
                          </div>
                        ) : data.status === 1 &&
                          ![0, 8].includes(userDetails.role) ? (
                          <div
                            className="crd-status-info"
                            style={{
                              borderColor: '#FFDE21',
                              color: '#FFDE21',
                            }}
                          >
                            Prijava u obradi
                          </div>
                        ) : (
                          ''
                        )}
                        {data.status === 2 && data.statusComment && (
                          <button
                            className="crd-reason-button"
                            onClick={() => handleShowReason()}
                          >
                            Pogledaj razlog
                          </button>
                        )}
                        {data.status === 1 &&
                          [0, 8].includes(userDetails.role) && (
                            <>
                              <button
                                className="crd-change-status-button crd-change-status-button-reject"
                                onClick={() => setRejectReportPopup(true)}
                              >
                                Odbaci
                              </button>
                              <button
                                className="crd-change-status-button crd-change-status-button-accept"
                                onClick={acceptIssueMutate}
                              >
                                Prihvati
                              </button>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="crd-information-buttons crd-information-buttons-desktop">
                    {data.status === 3 ||
                    data.status === 4 ||
                    data.status === 5 ? (
                      <div
                        className="crd-status-info"
                        style={{
                          borderColor: '#079C6A',
                          color: '#079C6A',
                        }}
                      >
                        Prijava prihvaćena
                      </div>
                    ) : data.status === 2 ? (
                      <div
                        className="crd-status-info"
                        style={{
                          borderColor: '#E74049',
                          color: '#E74049',
                        }}
                      >
                        Prijava odbačena
                      </div>
                    ) : data.status === 1 &&
                      ![0, 8].includes(userDetails.role) ? (
                      <div
                        className="crd-status-info"
                        style={{
                          borderColor: '#FFDE21',
                          color: '#FFDE21',
                        }}
                      >
                        Prijava u obradi
                      </div>
                    ) : (
                      ''
                    )}
                    {data.status === 2 && data.statusComment && (
                      <button
                        className="crd-reason-button"
                        onClick={() => handleShowReason()}
                      >
                        Pogledaj razlog
                      </button>
                    )}
                    {data.status === 1 && [0, 8].includes(userDetails.role) && (
                      <>
                        <button
                          className="crd-change-status-button crd-change-status-button-reject"
                          onClick={() => setRejectReportPopup(true)}
                        >
                          Odbaci
                        </button>
                        <button
                          className="crd-change-status-button crd-change-status-button-accept"
                          onClick={acceptIssueMutate}
                        >
                          Prihvati
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {rejectReportPopup && (
        <div className="crd-reject-modal-bg">
          <div className="reject-confirmation">
            <div className="reject-confirmation-title form-header">
              <div className="form-header-title">Odbacivanje kvara</div>
              <button
                style={{ fontWeight: 'bolder' }}
                className="form-close-button"
                onClick={() => setRejectReportPopup(false)}
              >
                <CloseForm style={{ height: '10px' }} />
              </button>
            </div>

            <div className="crd-reject-modal-body">
              <div className="crd-modal-body-title">
                Razlog odbacivanja kvara:
              </div>
              <form onSubmit={handleReject}>
                <textarea
                  type="text"
                  className="crd-field form-textbox crd-modal-field"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Unesite razlog odbacivanja"
                />
                <div>
                  <button
                    type="submit"
                    className="crd-confirm-rejection-button"
                  >
                    Potvrdi
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showMessage && (
        <ConfirmationMessage
          title={messageTitle}
          text={messageText}
          closeMessage={closeMessageModal}
        />
      )}
    </div>
  );
}

export default CitizenReportsInformation;
